module.exports = __webpack_public_path__ + "static/media/hello-emoji.afaad43a.png";